import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from 'thesis-and-dissertations/layouts/app/components/Header';
import Footer from 'thesis-and-dissertations/layouts/app/components/Footer';

import Image from '../../assets/img/thesis-covers.png'
import InputSearch from 'thesis-and-dissertations/layouts/app/components/InputSearch';

import { hasResearchType } from '../../helpers/helper'
import './style.css'

import Api from '../../helpers/api';
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError';
const api = new Api();

const Content = () => {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [categories, setCategories] = useState([])
    const [searchThesis, setSearchThesis] = useState({})
    const [totalThesis, setTotalThesis] = useState(0)

    useEffect(() => {
        // COMMENTED: Research type check - not needed without login system
        // if (!hasResearchType()) {
        //     navigate('/research-type')
        //     return
        // }

        fetch()
        fetchTotalThesis()
    }, [])

    const fetch = () => {
        setIsLoading(true)
        api.getScientificField({})
            .then(response => {
                setIsLoading(false)
                const data = response?.data;
                setCategories(data)
                setIsLoading(false)
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setIsLoading(false)
                handleApiError(error)
            })
    };

    const fetchTotalThesis = () => {
        api.getTotalThesis()
            .then(response => {
                const {data} = response
                setTotalThesis(data?.total)
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                handleApiError(error)
            })
    };

    const handleSearchThesis = (text) => {
        setSearchThesis({
            ...{ JudulTugasAkhir: text }
        })
    }

    const handleTopicPage = (id, name) => {
        navigate(`/content-search?category=${id}&categoryName=${name}`);
    }

    return (
        <div className='container-fluid p-0 overflow-hidden' style={{ backgroundColor: '#FAF9F5' }}>
            <Header button={true} />

            <div style={styles.bgImage} className='p-15 search-box'>
                <div className='py-15 search-box-content'>
                    <div className='text-center pt-15'>
                        <p className='display-6 fw-bold mb-5 text-white fw-bold title-thesis'>Tesis & Disertasi</p>
                        <p className='fs-6 fw-bold mb-15 text-white'>Berisi {totalThesis?.toLocaleString()} Karya Akhir Alumni LPDP</p>
                    </div>

                    <div className='d-flex justify-content-center'>
                        <InputSearch
                            categories={categories}
                            onSearchThesis={handleSearchThesis}
                            redirectPage="/content-search"
                            handleChangeValueInputSearch={() => { }}
                        />
                    </div>
                </div>
            </div>

            <div className='row px-15'>
                <div className='col-md-6 p-15'>
                    <p className='display-6 fw-bold text-black'>Connect with LPDP Alumni</p>
                    <p className='fs-6'>Share research, collaborate with your peers, and get the support you need to advance your career.</p>
                </div>
                <div className='col-md-6 p-15'>
                    <p className='fs-6 fw-bold'>VISIT TOPIC PAGE</p>

                    <div className='mt-6 col-md-8'>
                        {categories?.map((item, key) => {
                            return (
                                <span
                                    onClick={() => handleTopicPage(item.id_bidang_keilmuan, item.bidang_keilmuan)}
                                    key={key}
                                    className='badge badge-light p-4 m-2 rounded-pill text-primary'
                                    style={styles.badge}>{item.bidang_keilmuan}</span>
                            )
                        })}
                    </div>
                </div>
            </div>
            <Footer />
        </div >
    );
};

const styles = {
    bgImage: {
        backgroundColor: '#F95E2F',
        backgroundImage: `url(${Image})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        position: 'relative',
        height: '70vh'
    },
    badge: {
        border: '1px solid #F95E2F',
        cursor: 'pointer'
    },
    searchButton: {
        borderRadius: '0 5px 5px 0',
        border: 'none'
    }
}

export default Content;